






















































import {
  InstrumentPerformanceData
} from "@/shared/types";
import { Component, Prop, Vue } from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import { useInstrumentPerformanceDataStore } from "@/shared/store/instrumentPerformanceData";
import moment from "moment";

@Component
export default class MorningstarAnalystTable extends Vue {
  @Prop() symbol: string;
  @Prop() accountId: number;

  instrumentPerformanceDataStore = useInstrumentPerformanceDataStore();

  moment = moment;
  formatCurrency = formatCurrency;

  get instrumentPerformanceData (): InstrumentPerformanceData {
    return this.instrumentPerformanceDataStore.instrumentPerformanceData(this.symbol);
  }

  get hasEquityResearchData (): boolean {
    return !!this.instrumentPerformanceData.equityResearchRatings;
  }

  get previousDayClosePrice (): number {
    return this.instrumentPerformanceData.equityResearchRatings.closePrice;
  }

  get asOfClosePriceDate (): string {
    return moment(this.instrumentPerformanceData.equityResearchRatings.asOfClosePriceDate).format("MM/DD/YYYY");
  }

  formatFairValueUncertaintyDisplayCopy (value: number): string {
    switch (true) {
      case value < 0.1:
        return "Low";
      case value >= 0.1 && value < 0.15:
        return "Medium";
      case value >= 0.15 && value < 0.35:
        return "High";
      case value >= 0.35 && value < 0.80:
        return "Very High";
      case value >= 0.8:
        return "Extreme";
      default:
        return "N/A";
    }
  }

  formatPriceFairValueDisplayCopy (value: number): string {
    switch (true) {
      case value < 1:
        return "Under Valued";
      case value === 1:
        return "Fairly Valued";
      case value > 1:
        return "Over Valued";
      default:
        return "N/A";
    }
  }

  getIconStyleForIndex (index: number): string {
    const rating = this.parsedStarRating(this.instrumentPerformanceData.equityResearchRatings.quantitativeStarRating);

    return index <= rating ? "fa-solid" : "fa-regular";
  }

  parsedStarRating (valueAsString: string): number {
    return parseInt(valueAsString) || 0;
  }
}
